<template>
    <el-container class="approval-list">
        <el-main>
            <div class="tools-bar">
                <div class="tools-search" @keyup.enter="handleSearch">
                    <el-form :inline="true" class="demo-form-inline">
                       <el-form-item label="审批类型">
                            <BusinessTree
                                ref="treeChild"
                                style="width: 120px;"
                                v-if="isShowTree"
                                :popover="true"
                                :data="treeData"
                                :defaultProps="defaultProps"
                                :defaultClass="'business-tree-form'"
                                @nodeClick="handleTreeNode"
                            />
                        </el-form-item>
                        <el-form-item label="审批名称">
                            <el-input style="width: 120px;" maxlength="100" @change="handleSearch" v-model.trim="searchParams.approvalName" placeholder="审批流名称">
                            </el-input>
                        </el-form-item>
                        <el-form-item  label="申请人">
                            <el-input readonly style="width: 80px;" :title="searchParams.selectedUserNames" v-model="searchParams.selectedUserNames" @focus="chooseProcessAssigneeUser" ></el-input>
                            <UserOrgPop :key="loadTimer" :isShowUserOrg='isShowProcessUserOrg' :multiple='true' :selectedUser="selectedProcessUser" ref="processUserOrgPop" @nodeClick="processAssigneeSelectTrigger" />
                        </el-form-item>
                        <el-form-item  v-if="isShowProcessInfo" label="流程名称">
                            <el-input style="width: 120px;" maxlength="100" @change="handleSearch" v-model.trim="searchParams.busiProcessInstanceName" placeholder="所属流程名称">
                            </el-input>
                        </el-form-item>
                        <el-form-item  v-if="isShowProcessInfo" label="任务名称">
                            <el-input style="width: 120px;" maxlength="100" @change="handleSearch" v-model.trim="searchParams.taskName" placeholder="所属任务名称">
                            </el-input>
                        </el-form-item> 
                    </el-form>
                    <el-tooltip class="item" effect="light" content="当选择流程信息时，把审批相关所属流程和所在任务信息显示出来" placement="top">
                        <el-checkbox style='float:left' class="checkBox-style" v-model="hideProcessInfo" @change="handleHideProcessInfo"><el-tag size="mini">流程信息</el-tag></el-checkbox>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="列表模式将会把申请人、所属部门、申请时间等信息以列表方式展示" placement="top">
                        <el-checkbox style='float:left' class="checkBox-style" v-model="listMode"><el-tag size="mini">列表模式</el-tag></el-checkbox>
                    </el-tooltip>
                </div>
                <div class="tools-btn-group" ><!-- style="width:220px;" -->
                    <el-badge class="badge-item" >
                      <el-button type="primary" icon="el-icon-search" circle title="普通审批查询" @click="handleSearch"></el-button>
                    </el-badge>
                    <el-badge class="badge-item" >
                      <el-button icon="el-icon-s-data" type="primary" round title="表单关联查询,根据表单数据过滤查询" @click="handleFormFieldSearch"></el-button>
                    </el-badge>
                    <el-badge class="badge-item" >
                      <el-button  size="mini" type="primary" @click="showAllApprove()" v-if="isHasAuth()">查看全部审批</el-button>
                    </el-badge>
                    <template v-if="approvalStatus<20 && !isOuterRead">
                      <el-badge class="badge-item" >
                          <el-button icon="el-icon-circle-plus"  size="mini" type="primary" @click="handleNavAdd()">发起审批</el-button>
                      </el-badge>
                    </template>
                    <el-button v-if="!isFullScreen" type="primary" icon="el-icon-rank"  size="mini" @click.stop="handleFullScreenForApproval()">全屏</el-button>
                </div>
            </div>
            <div class="data-content">
                <el-table :data="approvalInstanceList" class="approvalInstanceListTable" :row-class-name="setClassName" :border="true" v-loading="loading" :height="approvalListHeight" style="margin-top:-10px">
                    <el-table-column
                        v-if="belongProcessFlag!==0"
                        prop="belong"
                        :show-overflow-tooltip="true"
                        width="80"
                        label="来源"
                        align="center"
                      >
                        <template slot-scope="scope">
                            <template v-if="scope.row.belong === 0" >【其他】</template>
                            <template v-if="scope.row.belong === 1" >【流程】</template>
                            <template v-if="scope.row.belong === 2" >【任务】</template>
                        </template>
                    </el-table-column>
                    <el-table-column  align="center" label="审批历史" type="expand"  width="50">
                      <template slot-scope="props">
                        <el-tabs style="width:100%" v-if="props.row.hasOwnProperty('children')" :tab-position="historyTabPosition" type="border-card">
                          <el-tab-pane v-for="(history, index2) in props.row.children" :key="index2" :label="'第'+(props.row.children.length-index2)+'轮'">
                            <el-form label-position="left" inline class="demo-table-expand">
                              <el-form-item class="approval-info" label="审批名称">
                                <div  style="cursor:pointer;" @click.stop="handleView(history)">
                                    <span style="font-weight: 700;color: rgb(48, 49, 51);font-size:16px;">{{ history.approvalName }}</span>
                                    <el-button size="mini" icon="el-icon-view" title="查看" circle @click="handleView(history)"></el-button>
                                </div>
                              </el-form-item>
                              <el-form-item class="approval-info" label="申请时间">
                                <span>{{ history.created }}</span>
                              </el-form-item>
                              <el-form-item class="approval-info" label="驳回时间">
                                <span>{{ history.modified }}</span>
                              </el-form-item>
                              <el-form-item style="width:100%" class="approval-steps" label="审批流状态" >
                                    <el-steps v-if="history.approvalMethod == 1 && history.approvalTotalNum>0" align-center finish-status="success">
                                      <el-step v-for="(item, index) in history.users" :class="activeClass(item)" :key="index" :title="item.trueName" :description="item.hasOwnProperty('approvalRemarks')?item.approvalRemarks:''"></el-step>
                                    </el-steps>
                                    <el-steps v-if="history.approvalMethod > 1 && history.approvalTotalNum>0" align-center finish-status="success">
                                        <el-step v-for="(item, index) in history.approVoList" :class="activeClass(item)" :key="index" align-center :description="item.hasOwnProperty('approvalRemarks')?item.approvalRemarks:''">
                                            <el-breadcrumb v-if="item && item.list.length > 0" slot="title" separator="/">
                                                <el-breadcrumb-item  v-for="(user, i) in item.list" :key="i" :class="activeUserClass(user)">{{user.trueName}}</el-breadcrumb-item>
                                            </el-breadcrumb>
                                        </el-step>
                                    </el-steps>
                              </el-form-item>
                            </el-form>
                          </el-tab-pane>
                        </el-tabs>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="审批名称"
                      :show-overflow-tooltip="true"
                      align="center"
                      min-width="230">
                      <template slot-scope="scope">
                          <div v-if="isCopyFlag===1" style="cursor:pointer;" @click.stop="handleView(scope.row)">
                            <template v-if="scope.row.carbonCopyStatus && (scope.row.carbonCopyStatus === 1)"> 
                              <span style="font-size:20px;color:#f56c6c">●</span>
                            </template >
                            <span style="font-weight: 700;color:#303133;font-size:16px;">{{ scope.row.approvalName }}</span>
                        </div>
                        <div v-else>
                          <span style="font-weight: 700;color:#303133;font-size:16px;">{{ scope.row.approvalName }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                       label="申请人信息"
                       :show-overflow-tooltip="true"
                       v-if="!listMode"
                       align="center"
                       width="210">
                        <template slot-scope="scope">
                          <span style="float: left;" > 申请人: &nbsp;{{ scope.row.applyUserName }}</span>
                          <br>
                          <el-tooltip class="item" effect="dark" :content="scope.row.applyUserDept" placement="top">
                            <span style="float: left;" > 所属部门: {{ scope.row.applyUserDept | ellipsis }}</span>
                          </el-tooltip>
                          <br>
                          <span style="float: left;" > 申请时间: {{ scope.row.created }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="listMode"
                        prop="applyUserName"
                        label="申请人"
                        :show-overflow-tooltip="true"
                        align="center"
                        width="80">
                    </el-table-column>
                    <el-table-column
                        v-if="listMode"
                        prop="applyUserDept"
                        label="所属部门"
                        :show-overflow-tooltip="true"
                        align="center"
                        width="100">
                    </el-table-column>
                    <el-table-column
                        v-if="listMode"
                        prop="created"
                        label="申请时间"
                        :show-overflow-tooltip="true"
                        align="center"
                        width="100">
                    </el-table-column>
                    <el-table-column
                        v-if="isShowProcessInfo"
                        prop="busiProcessInstanceName"
                        :show-overflow-tooltip="true"
                        width="110"
                        label="所属流程"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        v-if="isShowProcessInfo"
                        prop="taskName"
                        :show-overflow-tooltip="true"
                        width="110"
                        label="所在任务"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="approvalTypeName"
                        :show-overflow-tooltip="true"
                        width="80"
                        label="审批类型"
                        align="center"
                      >
                    </el-table-column>
                    <el-table-column
                      label="审批状态"
                      v-if="!listMode"
                      :show-overflow-tooltip="true"
                      align="center"
                      width="100">
                        <template slot-scope="scope">
                            <el-button size="mini" type="info" v-if="scope.row.approvalStatus==0" round>草稿</el-button>
                            <el-button size="mini" type="primary" v-if="scope.row.approvalStatus==1" round>审批中</el-button>
                            <el-button size="mini" type="success" v-if="scope.row.approvalStatus==2" round>通过</el-button>
                            <el-button size="mini" type="danger"  v-if="scope.row.approvalStatus==3" round>驳回</el-button>
                            <el-button size="mini" type="warning"  v-if="scope.row.approvalStatus==4" round>终止</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                      label="审批状态"
                      v-if="listMode"
                      :show-overflow-tooltip="true"
                      align="center"
                      width="100">
                        <template slot-scope="scope" >
                            <DynamicApprovalColumn
                                :isStatus="true"
                                :approvalTableData="getApprovalList(scope.row)"
                                :cellValue="scope.row['approvalStatus']"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column
                      label="审批状态详情"
                      v-if="!listMode"
                      align="center"
                      >
                      <template slot-scope="scope">
                        <div>
                            <el-steps v-if="scope.row.approvalMethod == 1 && scope.row.approvalTotalNum>0" align-center finish-status="success">
                                <el-step v-for="(item, index) in scope.row.users" :class="activeClass(item)" :key="index" :title="item.trueName" :description="item.hasOwnProperty('approvalRemarks')?item.approvalRemarks:''"></el-step>
                            </el-steps>
                            <el-steps v-if="scope.row.approvalMethod > 1 && scope.row.approvalTotalNum>0" align-center finish-status="success">
                                <el-step v-for="(item, index) in scope.row.approVoList" :class="activeClass(item)" :key="index" align-center :description="''">
                                    <el-breadcrumb v-if="item && item.list.length > 0" slot="title" :separator="(scope.row.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                                        <el-breadcrumb-item  v-for="(user, i) in item.list" :key="i" :class="activeUserClass(user)">{{user.trueName}}</el-breadcrumb-item>
                                    </el-breadcrumb>
                                </el-step>
                            </el-steps>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" fixed="right" width="180">
                      <template slot-scope="scope">
                            <el-button v-if="scope.row.approvalStatus>1 || approvalStatus==11 || approvalStatus==12 || approvalStatus==13 || approvalStatus==21 || approvalStatus==22 || (approvalStatus==23 && !scope.row.showApprovalBtn) || (scope.row.approvalStatus===1 && approvalStatus==14) || isCopyFlag==1 " size="mini" icon="el-icon-view" title="查看" circle @click="handleView(scope.row)"></el-button>
                            <template v-if="!isOuterRead">
                                <el-button v-if="scope.row.approvalStatus==0 || approvalStatus==10" type="primary" size="mini" icon="el-icon-plus" title="发起审批" circle @click="handleStartApproval(scope.row)"></el-button>
                                <el-button v-if="scope.row.approvalStatus==3 && (approvalStatus==13 || approvalStatus==14)" type="primary" size="mini" icon="el-icon-circle-plus" title="再次发起审批" circle @click="handleReStartApproval(scope.row)"></el-button>
                                <el-button v-if="approvalStatus<20 && scope.row.approvalStatus==1 && !scope.row.hasOwnProperty('passApproveUsers') && scope.row.createdBy===userInfo.userId" type="warning" size="mini" icon="el-icon-sold-out" title="撤回" circle @click="handleWithdraw(scope.row)"></el-button>
                                <!-- <el-badge class="badge-item" v-permission="permission.modifiedApprovalTemplateBtn">  -->
                                <el-badge class="badge-item">
                                    <el-button style="margin-left:-10px" v-if="approvalStatus==20 || (approvalStatus==23&&scope.row.showApprovalBtn)" type="success" size="mini" icon="el-icon-check" title="同意" circle @click="handlePass(scope.row)"></el-button>
                                    <el-button style="margin-left:0px" v-if="approvalStatus==20  || (approvalStatus==23&&scope.row.showApprovalBtn)" type="danger" size="mini" icon="el-icon-close" title="驳回" circle @click="handleReject(scope.row)"></el-button>
                                    <el-button style="margin-left:0px" v-if="approvalStatus==20  || (approvalStatus==23&&scope.row.showApprovalBtn)" type="primary" size="mini" icon="el-icon-setting" title="详细审批" circle @click="handleApproval(scope.row)"></el-button>
                                 <el-button style="margin-left:0px" v-if="approvalStatus==20  || (approvalStatus==23&&scope.row.showApprovalBtn)" type="warning" size="mini" icon="el-icon-s-promotion" title="审批转办" circle @click="transferApproval(scope.row)"></el-button>
                                </el-badge>
                            </template> 
                            <el-button v-if="scope.row.showApprovalDelBtn || scope.row.approvalStatus==0 || approvalStatus==10  ||  (scope.row.currentStep==0 && scope.row.createdBy===userInfo.userId) "   type="danger" size="mini" icon="el-icon-delete-solid" title="删除" circle @click="handleDelete(scope.row)"></el-button>
                        </template>
                    </el-table-column>
                  </el-table>
            </div>
            <div class="data-page">
                <el-row type="flex" justify="end">
                    <el-pagination
                        background
                        layout="total,sizes, prev, pager, next"
                        :total="page.totalPageNum"
                        :current-page="page.currentPage"
                        :page-size="page.pageSize"
                        :page-sizes="[5, 10, 20, 30, 50]"
                        @current-change="queryFormData"
                        @size-change="queryFormDataByPageSize"
                    />
                </el-row>
            </div>
        </el-main>
        <el-dialog
            :title="approvalTitle"
            width="90%"
            top="0vh"
            class="approval-pop-dialog"
            append-to-body
            :fullscreen=true
            v-if="isShowApprovalPop"
            :visible.sync="isShowApprovalPop"
            destroy-on-close
            >
            <ApprovalPop
                    v-if="isShowApprovalPop"
                    :key="loadTimer"
                    ref="approvalPop"
                    :isRough="isRough"
                    :instances="instances"
                    :isInstance="isInstance"
                    :approvalInfo="approvalInfo"
                    :approvalTemplateObj="templateInfo"
                    :btnMode="btnMode"
                    :isRead="isRead"
                    :isShowCopyUser="isShowCopyUser"
                    :busiProcessInstanceId="busiProcessInstanceId"
                    :approvalStatus="approvalStatus"
                    :busiTaskInstanceId="busiTaskInstanceId"
                    :taskParam="taskParam" />

            <span slot="footer" class="dialog-footer">
              <el-button v-if="btnMode===0||isRough" @click="handleSaveDraft" type="success">保存草稿</el-button>
              <el-button v-if="btnMode===0 || btnMode===3" @click="handleApply"  type="primary"  :loading="startApprovalloading">发起审批</el-button>
              <el-button v-if="btnMode===1" icon="el-icon-check" type="success" @click="handlePassApproval">同意</el-button>
              <el-button v-if="btnMode===1" icon="el-icon-close" type="danger" @click="handleRejectApproval">驳回</el-button>
              <el-button @click="isShowApprovalPop=false" type="info">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog
            width="90%"
            top="1vh"
            :visible.sync="isShowApprovalTemplate"
            append-to-body >
                <ApprovalTemplate ref="approvalTemplate" :busiProcessInstanceId="busiProcessInstanceId" :busiProcessInstanceName="busiProcessInstanceName" :busiTaskInstanceId="busiTaskInstanceId" :belongProcessFlag="belongProcessFlag" @closeApprovalTemplate="closeApprovalTemplate" :selectedTemplate="selectedTemplate" :taskParam="taskParam"/>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="isShowApprovalTemplate = false">取 消</el-button>
                </span>
        </el-dialog>
        <el-dialog
            width="96%"
            fullscreen
            top="1vh"
            title="全部审批"
            :visible.sync="isShowAllApprove"
			v-if="isShowAllApprove"
            custom-class="showAllApprove"
            append-to-body >
            <AllApproveList :busiProcessInstanceId="busiProcessInstanceId" :approvalStatus="approvalStatus" :busiTaskInstanceId="busiTaskInstanceId" :taskParam="taskParam">

            </AllApproveList>
        </el-dialog>
        <UserOrgPop :key="loadTimer2" :isShowUserOrg='isShowTransferUser' :multiple='false' :selectedUser="selectedTransferUser" ref="transferUserOrgPop" @nodeClick="transferSelectTrigger" />
        <el-dialog
            title="设置查询条件"
            append-to-body
            custom-class="field-item-link-pop-search"
            top="4vh"
            :visible.sync="isShowSearchConditon"
            :before-close="handleClose"
            >
            <SearchCondition  v-if="isShowSearchConditon"  ref="searchConditon" :readOnly="false" :conditionFields="conditionFields" :selectedModel="selectedModel" @chooseSearchConditon="chooseSearchConditon"/>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowSearchConditon = false">取 消</el-button>
                <el-button @click="resetSearchConditon">重置</el-button>
                <el-button type="primary" @click="chooseSearchConditon">确 定</el-button>
            </span>
        </el-dialog>
      </el-container>
</template>

<script>
    import * as constants from '@/common/constants';
    import { mapGetters, mapActions } from 'vuex';
    import { getIsCanApproval, getFormConfigs, delWithdrawApproval, getApprovalInstanceList, getSerialNumberDepartment, getBusinessTreeList, addPassApproval,
        addRejectApproval, deleteApprovalInstance, getSerialNumber, getSerialNumber2, updateRefSerialNumber, upDateSerialNumberState, updateApprovalUser, getSerialNumberPlus, updCarbonCopy } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import { isEmpty, cloneDeep } from 'lodash';
    import ApprovalPop from '@/components/ApprovalPop';
    import AllApproveList from '@/components/Approve/AllApproveList';
    import ApprovalTemplate from '@/pages/process/ProcessTemplate/ApprovalTemplate';
    import DynamicApprovalColumn from '@/components/DynamicTable/DynamicApprovalColumn';
    import SearchCondition from '@/components/SearchCondition';
    import { CONST_PERMISSION_PROCESS_DELETE_PROCESS_SERVICE_BTN,
        CONST_PERMISSION_PROCESS_PUBLISH_PROCESS_SERVICE_BTN,
        CONST_PERMISSION_PROCESS_DESIGN_PROCESSS_ERVICE_BTN,
        CONST_PERMISSION_PROCESS_MODIFIED_PROCESS_SERVICE_BTN,
        CONST_PERMISSION_PROCESS_PREVIEW_PROCESS_SERVICE_BTN,
        CONST_PERMISSION_PROCESS_ADD_PROCESS_SERVICE_BTN
    } from '@/common/constants';

    export default {
        components: {
            ApprovalPop,
            ApprovalTemplate,
            DynamicApprovalColumn,
            SearchCondition,
            AllApproveList
        },
        mixins: [ mixinsNav ],
        filters: {
            ellipsis: function (value) {
                if (!value) return '';
                if (value.length > 12) {
                    return value.slice(0, 12) + '...';
                }
                return value;
            }
        },
        data () {
            return {
                listMode: false, // 列表模式
                isShowProcessInfo: true,
                hideProcessInfo: true,
                isRough: false,
                loadTimer: '',
                isShowCopyUser: false,
                isShowApprovalTemplate: false,
                historyTabPosition: 'left',
                isRead: false,
                btnMode: 0, // 0申请-草稿 1审批
                selectedRowId: '',
                isShowApprovalPop: false,
                approvalTitle: '查看审批详情',
                startApprovalloading: false,
                isInstance: false,
                instances: {
                    id: '',
                    formObj: {}
                },
                approvalInfo: {
                    approvalRemarks: '',
                    selectedCopyUserIds: '',
                    selectedCopyUserNames: ''
                },
                approvalInstanceList: [],
                approvalStates: [],
                isShowConsole: false,
                processState: [{
                    value: 2,
                    label: '全部'
                }, {
                    value: 0,
                    label: '未发布'
                }, {
                    value: 1,
                    label: '已发布'
                }],
                page: {
                    currentPage: 1, // 当前页码
                    pageSize: 5, // 每页条数
                    totalPageNum: 0 // 总页数
                },
                isShowTree: false,
                isShowNewProcess: false,
                searchParams: {
                    processDefinitionId: '',
                    serviceName: '',
                    producer: '',
                    serviceType: '',
                    state: null,
                    busiProcessInstanceId: '',
                    busiTaskInstanceId: '',
                    isOther: false,
                    isCopyFlag: 0,
                    approveFromIds: '',
                    busiProcessInstanceName: '',
                    taskName: ''
                },
                loading: false,
                approvalList: [],
                treeData: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                processDefineList: [],
                processDefineSearchList: [{
                    value: '',
                    label: '全部'
                }],
                templateInfo: {
                    id: '',
                    templateName: '',
                    busiType: '',
                    busiTypeName: '',
                    remarks: '',
                    selectedUser: {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    },
                    templateState: null,
                    forms: [],
                    users: [],
                    dataOperate: {
                        dataSource: 2,
                        forms: []
                    },
                    parentApprovalId: '',
                    approvalMethod: 1,
                    mainApprovalId: ''
                },
                isShowSetting: false,
                taskList: [],
                processInstance: {
                    processServiceName: '',
                    name: ''
                },
                // approvalListHeight: this.isFullScreen ? '370' : (this.belongProcessFlag === 1 ? '320' : (this.belongProcessFlag === 2 ? '280' : '442')),
                approvalListHeight: window.screen.width <= 1366 ? '54vh' : '64vh',
                newProcessTitle: '',
                archiveTemplateList: [],
                archiveTemplateTreeList: [], // 档案模板树型列表数据
                permission: {
                    deleteProcessServiceBtn: [
                        CONST_PERMISSION_PROCESS_DELETE_PROCESS_SERVICE_BTN
                    ],
                    publishProcessServiceBtn: [
                        CONST_PERMISSION_PROCESS_PUBLISH_PROCESS_SERVICE_BTN
                    ],
                    designProcessServiceBtn: [
                        CONST_PERMISSION_PROCESS_DESIGN_PROCESSS_ERVICE_BTN
                    ],
                    modifiedProcessServiceBtn: [
                        CONST_PERMISSION_PROCESS_MODIFIED_PROCESS_SERVICE_BTN
                    ],
                    previewProcessServiceBtn: [
                        CONST_PERMISSION_PROCESS_PREVIEW_PROCESS_SERVICE_BTN
                    ],
                    addProcessServiceBtn: [
                        CONST_PERMISSION_PROCESS_ADD_PROCESS_SERVICE_BTN
                    ]
                },
                totalPageNum: 0,
                isShowAllApprove: false,
                refCascadeInstanceId: null, // 级联更新流水号对应表单实例id
                selectedProcessUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                isShowProcessUserOrg: false,
                isShowTransferUser: false,
                selectedTransferUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                loadTimer2: '',
                transferApprovalData: {},
                isShowSearchConditon: false,
                conditionFields: [],
                conditionLoaderKey: false,
                selectedModel: {formId: '', modelId: ''},
                formFieldSearchMode: false
            };
        },
        props: {
            approvalStatus: {
                type: Number
            },
            processType: {
                type: String
            },
            taskParam: {// 任务对象,用于暂存
                type: Object
            },
            busiProcessInstanceId: {
                type: String
            },
            busiProcessInstanceName: {
                type: String
            },
            busiTaskInstanceId: {
                type: String
            },
            belongProcessFlag: {
                type: Number,
                default: 0
            },
            isFullScreen: { // 是否全屏
                type: Boolean,
                default: true
            },
            isOther: {// 是否查询其他
                type: Boolean,
                default: false
            },
            isCopyFlag: {// 是否是抄送人
                type: Number,
                default: 0
            },
            copyFlagRead: {// 未读1，已读2
                type: Number,
                default: 0
            },
            selectedTemplate: {
                type: Array,
                default: () => { return []; }
            },
            isOuterRead: {
                type: Boolean,
                default: false
            },
            approveFromIds: {
                type: String,
                default: ''
            }
        },
        computed: {
            ...mapGetters([
                'userInfo',
                'menuRemindNum'
            ])
        },
        watch: {
            totalPageNum (val) {
                let mrd = cloneDeep(this.menuRemindNum);
                if (this.approvalStatus === 11) {
                    if (mrd.myApply && mrd.myApply.length > 0) {
                        mrd.myApply[0].num = val;
                    }
                    this[constants.VUEX_ACTIONS_REMIND_NUM](mrd);// 更新待办事项各个角标的值
                } else if (this.approvalStatus === 20) {
                    if (mrd.myApprove && mrd.myApprove.length > 0) {
                        mrd.myApprove[0].num = val;
                    }
                    this[constants.VUEX_ACTIONS_REMIND_NUM](mrd);// 更新待办事项各个角标的值
                } else if (this.approvalStatus === -1 && mrd.myCarbonCopy) {
                    mrd.myCarbonCopy[0].num = val;
                    this[constants.VUEX_ACTIONS_REMIND_NUM](mrd);// 更新待办事项各个角标的值
                }
            }
        },
        created () {
            this.selectedRowId = '';
            this.isRead = false;
            this.isRough = false;
            this._getFormData();
        },
        methods: {
            ...mapActions([
                constants.VUEX_ACTIONS_REMIND_NUM,
                constants.VUEX_ACTIONS_SIDEBAR_TOGGLE
            ]),
            async _initProcessDefineSearchList (list) {
                this.processDefineSearchList = Object.assign([], list);
                this.processDefineSearchList.unshift({value: '', name: '全部', key: ''});
                // console.log(this.processDefineSearchList);
            },
            async _getFormData () {
                this.loading = true;
                this.searchParams.busiProcessInstanceId = this.busiProcessInstanceId;// 业务流程实例ID
                this.searchParams.busiTaskInstanceId = this.busiTaskInstanceId;// 业务流程任务实例ID
                if (!this.isOther) {
                    this.searchParams.approvalStatus = this.approvalStatus;
                } else {
                    this.searchParams.isOther = this.isOther;
                }
                this.searchParams.isCopyFlag = this.isCopyFlag;
                this.searchParams.copyFlagRead = this.copyFlagRead;
                this.searchParams.approveFromIds = this.approveFromIds;
                let formData = await getApprovalInstanceList(Object.assign({}, {
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize
                }, this.searchParams));
                if (formData) {
                    this.approvalInstanceList = formData.data;
                    if (this.approvalStatus === 23) { // 全部审批
                        if (this.approvalInstanceList && this.approvalInstanceList.length > 0) {
                            for (let i = 0; i < this.approvalInstanceList.length; i++) {
                                let item = this.approvalInstanceList[i];
                                if (item.approvalStatus === 1) {
                                    if (item.approvalUserIds.indexOf(this.userInfo.userId) !== -1 && (isEmpty(item.processedUserIds) || item.processedUserIds.indexOf(this.userInfo.userId) === -1)) {
                                        item.showApprovalBtn = true; // 显示审批按钮
                                    } else {
                                        item.showApprovalBtn = false;
                                    }
                                } else {
                                    item.showApprovalBtn = false;
                                }
                            }
                        }
                    }
                    this.page = {
                        currentPage: formData.currentPage,
                        pageSize: formData.pageSize,
                        totalPageNum: formData.totalPageNum
                    };
                    this.totalPageNum = formData.totalPageNum;
                }
                this.loading = false;
                let businessTreeList = await getBusinessTreeList();
                this.treeData = businessTreeList;
                this.isShowTree = true;
            },
            queryFormData (currentPage) {
                this.page.currentPage = currentPage;
                this._getFormData();
            },
            queryFormDataByPageSize (pageSize) {
                this.page.pageSize = pageSize;
                this._getFormData();
            },
            handleSearch () {
                if (this.formFieldSearchMode) {
                    this.formFieldSearchMode = false;
                    this[constants.VUEX_ACTIONS_SIDEBAR_TOGGLE]();
                }
                this.searchParams.formFieldSearchMode = false;
                this.searchParams.searchCondition = null;
                this.queryFormData(1);
            },
            handleNavAdd () {
                // this.processEditInfo.serviceKey = `ps_${Date.now()}`;
                if (this.belongProcessFlag !== 0) { // 0：默认,1：从我的流程过来的，2：我的任务过来的
                    this.isShowApprovalTemplate = true;
                } else {
                    window.sessionStorage.setItem('isShowApproval', true);
                    this.navMyApprovalTemplateForApply();
                }
            },
            handleTreeNode (data, node, tree) {
                this.searchParams.approvalType = data.id;
                this.handleSearch();
            },
            activeClass (item) {
                if (item.stepStatus === 1) {
                    return 'success-step';
                } else if (item.stepStatus === 2) {
                    return 'reject-step';
                } else if (item.stepStatus === 99) {
                    return 'now-step';
                } else {
                    return '';
                }
            },
            activeUserClass (item) {
                if (item.stepStatus === 1) {
                    return 'success-user';
                } else if (item.stepStatus === 2) {
                    return 'reject-user';
                } else if (item.stepStatus === 99) {
                    return 'now-user';
                } else {
                    return '';
                }
            },
            async handleSaveDraft () {
                // opType 操作模式：1 保存草稿 2发起审批
                let isToApproval = this.$refs.approvalPop.isToApproval();
                if (!isToApproval) {
                    return;
                }
                this.btnMode = 0;
                this.isRead = false;
                let isValid = await this.$refs.approvalPop.handelSaveForms(1);
                // console.log(isValid);
                if (!isValid) {
                    this.isShowApprovalPop = false;
                    await this._getFormData();
                }
            },
            handleApply () {
                let isToApproval = this.$refs.approvalPop.isToApproval();
                if (!isToApproval) {
                    return;
                }
                this.btnMode = 0;
                this.isRead = false;
                let hasApplyUser = this.$refs.approvalPop.hasApplyUser();
                if (hasApplyUser) {
                    this.$confirm(`审批人中含有申请人,您确定要发起审批吗？`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async (res) => {
                        this.startApprovalloading = true;
                        let isValid = await this.$refs.approvalPop.handelSaveForms(2);
                        if (!isValid) {
                            this.isShowApprovalPop = false;
                            this.$emit('handleApplyTabClick', {index: '0'});
                        }
                        this.startApprovalloading = false;
                    }).catch(() => {
                    });
                } else {
                    // opType 操作模式：1 保存草稿 2发起审批
                    this.$confirm(`您确定要发起审批吗？`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async (res) => {
                        this.startApprovalloading = true;
                        let isValid = await this.$refs.approvalPop.handelSaveForms(2);
                        if (!isValid) {
                            this.isShowApprovalPop = false;
                            this.$emit('handleApplyTabClick', {index: '0'});
                        }
                        this.startApprovalloading = false;
                    }).catch(() => {});
                }
            },
            generateUUID () {
                var d = new Date().getTime();
                if (window.performance && typeof window.performance.now === 'function') {
                    d += window.performance.now(); // use high-precision timer if available
                }
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid.replace(RegExp('-', 'g'), '');
            },
            async handleStartApproval (row) { // 初次发起审批
                if (row.tempFormData) {
                    this.approvalInfo.tempFormData = row.tempFormData;
                    this.approvalInfo.mainModelInfo = JSON.parse(row.tempFormData);
                    this.templateInfo.mainModelInfo = JSON.parse(row.tempFormData);
                }
                this.btnMode = 3;// 解决草稿中，发起申请，审批名称无法发现出来的bug
                if (this.approvalStatus === 10) {
                    this.isRough = true;
                }
                // if (this.selectedRowId !== row.id) {
                await this.initApprovalPop(row);
                // }
                // this.loadTimer = new Date().getTime();
                this.isShowApprovalPop = true;
            },
            async handleReStartApproval (row) { // 再次发起审批
                this.isRough = true;// 再次发起审批，弹出框审批记录不需要显示
                this.btnMode = 3;
                this.isRead = false;
                row.opType = 2;
                row.parentApprovalId = row.id;// 上一轮审批流id
                row.oldProcessInstanceId = row.processInstanceId;// 上一轮审批流id
                row.id = null;// 新生成主键
                row.processInstanceId = this.generateUUID();// 复制主键到流程id
                this.templateInfo.parentApprovalId = row.parentApprovalId;
                this.templateInfo.mainApprovalId = row.mainApprovalId;
                this.templateInfo.isDeleteOldData = row.isDeleteOldData;
                this.busiTaskInstanceId = row.busiTaskInstanceId;
                await this.initApprovalPop(row, true);
                this.isShowApprovalPop = true;
            },
            async initApprovalPop (row, isReStartApproval) {
                this.selectedRowId = row.id;
                this.templateInfo = row;
                this.templateInfo.selectedUser = {};
                this.templateInfo.selectedUser.selectedUserIds = row.selectedUserIds;
                this.templateInfo.selectedUser.selectedUserNames = row.selectedUserNames;
                this.templateInfo.templateName = row.approvalName;
                this.templateInfo.busiType = row.approvalType;
                this.templateInfo.busiTypeName = row.approvalTypeName;
                this.templateInfo.opType = row.opType;
                this.instances.id = row.processInstanceId;
                if (isReStartApproval) {
                    this.instances.oldApproveInstanceId = row.oldProcessInstanceId;
                }
                this.isInstance = true;
                this.loadTimer = new Date().getTime();
                await this.initStruct(row);
                setTimeout(() => { // 默认回显值
                    this.$refs.approvalPop._initPage();
                }, 0);
            },
            async initStruct (row) {
                let formIds = [];
                row.forms.forEach(element => {
                    formIds.push(element.formId);
                });
                let formsMap = await getFormConfigs(formIds.join(','));
                this.instances.formObj = {};
                this.instances.formObj.structure = [];
                this.instances.formObj.instance = row.formValues;
                for (var key in formsMap) {
                    if (formsMap[key]) {
                        this.instances.formObj.structure.push(formsMap[key]);
                    }
                }
            },
            async handleView (row) {
                this.btnMode = 2;
                row.opType = 0;
                await this.initApprovalPop(row);
                if (row.carbonCopyStatus && row.carbonCopyStatus === 1) {
                    row.carbonCopyStatus = 2;
                    this.updCarbonCopy(row);// 更新抄送记录
                }
                this.isRead = true;
                this.isShowApprovalPop = true;
            },
            async handleApproval (row) { // 进行审批
                this.btnMode = 1;
                row.opType = 0;
                // if (this.selectedRowId !== row.id) {
                await this.initApprovalPop(row);
                // }
                this.isRead = true;
                // this.loadTimer = new Date().getTime();
                this.isShowApprovalPop = true;
                this.isShowCopyUser = true;
            },
            async handlePass (row) {
                let approvalUser = {};
                approvalUser.approvalInstanceId = row.id;
                approvalUser.approvalResult = 1;
                let ret = await getIsCanApproval(approvalUser);
                if (!ret.isCanApproval) { // true
                    if (row.orderMode === 1) {
                        this.messageTip('固定顺序审批模式，已审批过或尚有审批人未完成审批', 'warning');
                        return;
                    } else {
                        this.messageTip('您已无法审批，当前审批已审批过或者被删除', 'warning');
                        return;
                    }
                }
                this.$prompt('审批意见', '通过审批', {
                    confirmButtonText: '通过',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputValue: '同意',
                    inputErrorMessage: '请输入审批意见',
                    beforeClose: async (action, instance, done) => {
                        if (action === 'confirm') {
                            await this.getSerialNumberForApproval(row, approvalUser);
                            instance.confirmButtonLoading = true;
                            instance.confirmButtonText = '审批通过中...';
                            approvalUser.approvalRemarks = instance.inputValue;
                            // console.log(approvalUser);
                            await addPassApproval(approvalUser);
                            if (this.refCascadeInstanceId) {
                                // await updateRefSerialNumber(this.refCascadeInstanceId);// 级联更新流水号引用实例
                                updateRefSerialNumber(this.refCascadeInstanceId);// 异步处理, 级联更新流水号引用实例
                            }
                            done();
                        } else {
                            done();
                        }
                        setTimeout(() => {
                            instance.confirmButtonLoading = false;
                        }, 100);
                    }
                }).then(async ({ value }) => {
                    await this._getFormData();
                }).catch(() => {});
            },
            async handleReject (row) {
                let approvalUser = {};
                approvalUser.approvalInstanceId = row.id;
                approvalUser.approvalResult = 2;
                let ret = await getIsCanApproval(approvalUser);
                if (!ret.isCanApproval) { // true
                    if (row.orderMode === 1) {
                        this.messageTip('固定顺序审批模式，已审批过或尚有审批人未完成审批', 'warning');
                        return;
                    } else {
                        this.messageTip('您已无法审批，当前审批已审批过或者被删除', 'warning');
                        return;
                    }
                }
                this.$prompt('审批意见', '驳回审批', {
                    confirmButtonText: '驳回',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputValue: '不同意',
                    inputErrorMessage: '请输入审批意见',
                    beforeClose: async (action, instance, done) => {
                        if (action === 'confirm') {
                            instance.confirmButtonLoading = true;
                            approvalUser.approvalRemarks = instance.inputValue;
                            instance.confirmButtonText = '审批驳回中...';
                            await addRejectApproval(approvalUser);
                            done();
                        } else {
                            done();
                        }
                        setTimeout(() => {
                            instance.confirmButtonLoading = false;
                        }, 100);
                    }
                }).then(async ({ value }) => {
                    await this._getFormData();
                }).catch(() => {});
            },
            handleDelete (row) {
                let loading = '';
                this.$confirm(`删除后审批数据恢复不了, 您确定要删除审批数据吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await deleteApprovalInstance(row.id);
                    await this._getFormData();
                    this.isShowApprovalPop = false;
                    loading.close();
                }).catch(() => {
                    loading.close();
                });
            },
            async handlePassApproval () {
                let approvalUser = {};
                approvalUser.approvalInstanceId = this.selectedRowId;
                let ret = await getIsCanApproval(approvalUser);
                if (!ret.isCanApproval) { // true
                    if (this.approvalInfo.orderMode === 1) {
                        this.messageTip('固定顺序审批模式，已审批过或尚有审批人未完成审批', 'warning');
                        return;
                    } else {
                        this.messageTip('您已无法审批，当前审批已审批过或者被删除', 'warning');
                        return;
                    }
                }
                let isValid = await this.$refs.approvalPop.checkFormValid(0, ret);
                if (isValid) {
                    this.messageTip('表单内有必填字段，请填完后再审批', 'warning');
                    return;
                }
                let loading = '';
                this.$confirm(`您确定要通过审批吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    approvalUser.approvalResult = 1;
                    approvalUser.approvalRemarks = this.approvalInfo.approvalRemarks;
                    approvalUser.formJson = this.approvalInfo.formJson;
                    this.formData = this.approvalInfo.formJson;
                    approvalUser.selectedCopyUserIds = this.approvalInfo.selectedCopyUserIds;
                    approvalUser.selectedCopyUserNames = this.approvalInfo.selectedCopyUserNames;
                    this.approvalInfo.approvalTotalNum = this.approvalInfo.approvalList.length;
                    await this.getSerialNumberForApproval(this.approvalInfo, approvalUser);
                    await addPassApproval(approvalUser);
                    if (this.refCascadeInstanceId) {
                        // await updateRefSerialNumber(this.refCascadeInstanceId);// 级联更新流水号引用实例
                        updateRefSerialNumber(this.refCascadeInstanceId);// 异步处理, 级联更新流水号引用实例
                    }
                    await this._getFormData();
                    this.isShowApprovalPop = false;
                    loading.close();
                }).catch(() => {
                    loading.close();
                });
            },
            async handleRejectApproval () {
                let approvalUser = {};
                approvalUser.approvalInstanceId = this.selectedRowId;
                let ret = await getIsCanApproval(approvalUser);
                if (!ret.isCanApproval) { // true
                    if (this.approvalInfo.orderMode === 1) {
                        this.messageTip('固定顺序审批模式，已审批过或尚有审批人未完成审批', 'warning');
                        return;
                    } else {
                        this.messageTip('您已无法审批，当前审批已审批过或者被删除', 'warning');
                        return;
                    }
                }
                let isValid = await this.$refs.approvalPop.checkFormValid(1, ret);
                if (isValid) {
                    this.messageTip('表单内有必填字段，请填完后再审批', 'warning');
                    return;
                }
                let loading = '';
                this.$confirm(`您确定要驳回审批吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    approvalUser.approvalResult = 2;
                    approvalUser.approvalRemarks = this.approvalInfo.approvalRemarks;
                    approvalUser.formJson = this.approvalInfo.formJson;
                    // console.log(approvalUser);
                    approvalUser.selectedCopyUserIds = this.approvalInfo.selectedCopyUserIds;
                    approvalUser.selectedCopyUserNames = this.approvalInfo.selectedCopyUserNames;
                    await addRejectApproval(approvalUser);
                    await this._getFormData();
                    this.isShowApprovalPop = false;
                    loading.close();
                }).catch(() => {
                    loading.close();
                });
            },
            handleWithdraw (row) {
                let loading = '';
                this.$confirm(`您确定要撤回当前审批为草稿状态吗，已上传的文件和评论也会被删除!`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await delWithdrawApproval(row);
                    this.$emit('handleApplyTabClick', {index: '3'});
                    loading.close();
                }).catch(() => {
                    loading.close();
                });
            },
            async getSerialNumberForApproval (row, approvalUser) {
                let isLastApproval = false;
                for (var i = 0; i < row.approvalList.length; i++) {
                    for (var j = 0; j < row.approvalList[i].length; j++) {
                        if (row.approvalList[i][j].userId === this.userInfo.userId) {
                            if (row.orderMode === 0 && row.countersignUsers && row.countersignUsers.length > 0) {
                                isLastApproval = true;
                            } else if (row.approvalTotalNum === (i + 1)) {
                                if (row.approvalMethod === 1) { // 普通审批，最后一审通过
                                    isLastApproval = true;
                                } else if (row.approvalUserGroupList && (row.approvalUserGroupList.length - i) > 0) {
                                    if (row.approvalUserGroupList[i].approvalMultiSignType === 2) { // 最后一审为或签
                                        // 最后一审为会签
                                        let lastApprovalRes = 1;
                                        for (var k = 0; k < row.approvalList[i].length; k++) {
                                            if (row.approvalList[i][k].userId !== this.userInfo.userId) {
                                                lastApprovalRes = lastApprovalRes & row.approvalList[i][k].approvalResult;
                                            }
                                        }
                                        if (lastApprovalRes > 0) {
                                            isLastApproval = true;
                                        }
                                    } else {
                                        isLastApproval = true;
                                    }
                                }
                            }
                        }
                    }
                }
                if (isLastApproval) {
                    if (!approvalUser.formJson) {
                        approvalUser.formJson = JSON.parse(row.formValues);
                    }
                    await this.renderSerialNumber(row, approvalUser.formJson);
                }
                approvalUser.isLastApproval = isLastApproval;
            },
            async renderSerialNumber (row, formJson) {
                if (row.forms) {
                    // 为适配两个审批通过的差异性
                    await this.initStruct(row);
                }
                for (var findex = 0; findex < this.instances.formObj.structure.length; findex++) {
                    let formInfo = this.instances.formObj.structure[findex];
                    // 流水号保存生成字段渲染
                    if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                        let formData = {};
                        formJson.forEach(d => {
                            if (d.formId === formInfo.id) {
                                formData = d;
                            }
                        });
                        for (var fieldIndex = 0; fieldIndex < formInfo.fieldsList.length; fieldIndex++) {
                            let field = formInfo.fieldsList[fieldIndex];
                            // 假如是流水号字段并且流水号有值的情况下就不走流水号生成逻辑了
                            if (field.type === 'serialNumber' && !isEmpty(formData.values[field.id])) {
                                console.log(field.name + '---------' + field.type);
                                console.log(formData.values[field.id]);
                                continue;
                            }
                            if (field.type === 'subform' && formData.values[field.id] && formData.values[field.id].length > 0) {
                                for (var dataIndex = 0; dataIndex < formData.values[field.id].length; dataIndex++) {
                                    var subData = formData.values[field.id][dataIndex];
                                    for (var subFieldIndex = 0; subFieldIndex < field.options.fieldList.length; subFieldIndex++) {
                                        let subField = field.options.fieldList[subFieldIndex];
                                        if (subField.type === 'serialNumber' && subField.options.ext3 === '4' && field.options.config.options.length > 0 && !subData[subField.id]) {
                                            await this.setSerialNumber(subField.options.config.options[0].value, subField, subData, formInfo);
                                        }
                                    }
                                }
                            } else if (field.type === 'serialNumber' && field.options.ext3 === '4' && field.options.config.options.length > 0 && !formData.values[field.formField]) {
                                await this.setSerialNumber(field.options.config.options[0].value, field, formData.values, formInfo);
                            } else if (field.type === 'serialNumber' && field.options.ext3 === '6') { // 根据字段值进行生成流水号
                                let ext2Obj = JSON.parse(field.options.ext2);
                                let curFieldValue = formData.values[ext2Obj.seriaNumberGenerateFieldId];
                                if (ext2Obj.seriaNumberGenerateFieldIdValue && typeof (ext2Obj.seriaNumberGenerateFieldIdValue) === 'object') {
                                    for (let i = 0; i < ext2Obj.seriaNumberGenerateFieldIdValue.length; i++) {
                                        if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue[i]) {
                                            await this.setSerialNumber(field.options.config.options[0].value, field, formData.values, formInfo);
                                        }
                                    }
                                } else {
                                    if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue) {
                                        await this.setSerialNumber(field.options.config.options[0].value, field, formData.values, formInfo);
                                    }
                                }
                            } else if (field.type === 'serialNumber') { // 多规则的流水号生成规则
                                let ext2 = field.options.ext2;
                                if (ext2) {
                                    let ext2Obj = JSON.parse(ext2);
                                    if (ext2Obj.moreSerialNumber) { // 多规则配置
                                        let seriaNumberAutoincrementType = null;
                                        let serialNumberRuleList = ext2Obj.serialNumberRuleList;
                                        for (let i = 0; i < serialNumberRuleList.length; i++) {
                                            let element = serialNumberRuleList[i];
                                            let takeEffectField = element.takeEffectField;
                                            let takeEffectFieldValue = element.takeEffectFieldValue;
                                            let formFieldVal = formData.values[takeEffectField];
                                            if (element.seriaNumberAutoincrementType) { // 说明配置了自增体 1部门自增体 流水号自增体
                                                seriaNumberAutoincrementType = element.seriaNumberAutoincrementType;
                                            }
                                            if (takeEffectFieldValue.indexOf(formFieldVal) !== -1) { // 满足条件了
                                                if (element.seriaNumberDepartTypeFormFieldId) {
                                                    ext2Obj.seriaNumberDepartTypeFormFieldId = element.seriaNumberDepartTypeFormFieldId;
                                                }
                                                if (element.seriaNumberDepartTypeFormFieldIdValue) {
                                                    ext2Obj.seriaNumberDepartTypeFormFieldIdValue = element.seriaNumberDepartTypeFormFieldIdValue;
                                                }
                                                if (element.seriaNumberSelectTypeFormFieldId) {
                                                    ext2Obj.seriaNumberSelectTypeFormFieldId = element.seriaNumberSelectTypeFormFieldId;
                                                }
                                                field.options.ext2 = JSON.stringify(ext2Obj);
                                                await this.setSerialNumber(element.selectedNode.id, field, formData.values, formInfo, seriaNumberAutoincrementType);
                                                break;
                                            }
                                        }
                                    }
                                }
                            } else if (field.type === 'text') {
							    if (field.options.upMoneyField) { // 配置了金额大写
							        let upMoneyId = field.options.upMoneyField;
							        let res = this.convertCurrency(formData.values[upMoneyId]);
							        formData.values[field.id] = res;
							    }
                            }
                        }
                    }
                }
            },
            async setSerialNumber (sid, field, formData, formInfo, seriaNumberAutoincrementType) {
                if (sid) {
                    // console.log(field);
                    // console.log(formData);
                    let instanceId = null;
                    this.refCascadeInstanceId = null;
                    let serialNumberRefId = null;
                    let serialNumberRelationFormId = null;
                    let serialNumberRelationFieldId = null;
                    if (field.ext1) {
                        let serialNumberRelation = JSON.parse(field.ext1);
                        serialNumberRefId = serialNumberRelation.serialNumberRefId;
                        serialNumberRelationFormId = serialNumberRelation.serialNumberRelationFormId;
                        serialNumberRelationFieldId = serialNumberRelation.serialNumberRelationFieldId;
                        instanceId = formData[serialNumberRefId].tableData[0].id;
                    }
                    let numberObj = null;
                    let departmentId = null;
                    if (field.options.ext2) {
                        let ext2Obj = JSON.parse(field.options.ext2);
                        if (ext2Obj.seriaNumberFormFieldId) { // 部门占位符取值
                            departmentId = formData[ext2Obj.seriaNumberFormFieldId];
                            if (departmentId) {
                                departmentId = Number(departmentId);
                                let param = {id: sid, departmentId: departmentId};
                                numberObj = await getSerialNumberDepartment(param);
                                if (seriaNumberAutoincrementType) {
                                    param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                }
                            } else {
                                this.$message.error('流水号关联的部门未选取,数据无法生成流水号');
                                return;
                            }
                        } else if (ext2Obj.seriaNumberBusinessTypeFormFieldId && ext2Obj.seriaNumberDepartTypeFormFieldId) { // 业务分类和部门都选择的
                            let businessId = formData[ext2Obj.seriaNumberBusinessTypeFormFieldId];
                            let departId = formData[ext2Obj.seriaNumberDepartTypeFormFieldId];
                            let param = {id: sid, businessId: businessId, businessField: ext2Obj.seriaNumberBusinessTypeFormFieldIdValue, departId: departId, departField: ext2Obj.seriaNumberDepartTypeFormFieldIdValue};
                            if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                                let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                                if (fieldVal) { // 下拉选项选值了
                                    let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                    let options = fieldObj.options.config.options;
                                    let optionsObj = options.find(element => element.value === fieldVal);
                                    // if (optionsObj.serialNumberValue) {
                                    param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                    param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                    if (seriaNumberAutoincrementType) {
                                        param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                    }
                                    // }
                                }
                            }
                            numberObj = await getSerialNumberPlus(param);
                        } else if (ext2Obj.seriaNumberBusinessTypeFormFieldId) { // 业务分类
                            let businessId = formData[ext2Obj.seriaNumberBusinessTypeFormFieldId];
                            let param = {id: sid, businessId: businessId, businessField: ext2Obj.seriaNumberBusinessTypeFormFieldIdValue};
                            if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                                let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                                if (fieldVal) { // 下拉选项选值了
                                    let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                    let options = fieldObj.options.config.options;
                                    let optionsObj = options.find(element => element.value === fieldVal);
                                    // if (optionsObj.serialNumberValue) {
                                    param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                    param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                    if (seriaNumberAutoincrementType) {
                                        param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                    }
                                    // }
                                }
                            }
                            numberObj = await getSerialNumberPlus(param);
                        } else if (ext2Obj.seriaNumberDepartTypeFormFieldId) { // 部门
                            let departId = formData[ext2Obj.seriaNumberDepartTypeFormFieldId];
                            let param = {id: sid, departId: departId, departField: ext2Obj.seriaNumberDepartTypeFormFieldIdValue};
                            if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                                let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                                if (fieldVal) { // 下拉选项选值了
                                    let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                    let options = fieldObj.options.config.options;
                                    let optionsObj = options.find(element => element.value === fieldVal);
                                    // if (optionsObj.serialNumberValue) {
                                    param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                    param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                    if (seriaNumberAutoincrementType) {
                                        param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                    }
                                    // }
                                }
                            }
                            numberObj = await getSerialNumberPlus(param);
                        } else if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                            let param = {id: sid};
                            if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                                let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                                if (fieldVal) { // 下拉选项选值了
                                    let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                    let options = fieldObj.options.config.options;
                                    let optionsObj = options.find(element => element.value === fieldVal);
                                    //   if (optionsObj.serialNumberValue) {
                                    param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                    param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                    if (seriaNumberAutoincrementType) {
                                        param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                    }
                                    //   }
                                }
                            }
                            numberObj = await getSerialNumberPlus(param);
                        } else {
                            if (instanceId && serialNumberRefId) {
                                numberObj = await getSerialNumber2(instanceId, serialNumberRefId, serialNumberRelationFormId, serialNumberRelationFieldId);
                                this.refCascadeInstanceId = instanceId;
                            } else {
                                numberObj = await getSerialNumber(sid);
                            }
                        }
                    } else {
                        if (instanceId && serialNumberRefId) {
                            numberObj = await getSerialNumber2(instanceId, serialNumberRefId, serialNumberRelationFormId, serialNumberRelationFieldId);
                            this.refCascadeInstanceId = instanceId;
                        } else {
                            numberObj = await getSerialNumber(sid);
                        }
                    }
                    if (numberObj) {
                        formData[field.id] = numberObj.newSerialNumber;
                        formData[field.id + '-sn'] = numberObj.sn;
                    }
                    // 更新流水号记录为已使用状态
                    let param = {id: numberObj.sn, serialNumber: numberObj.newSerialNumber};
                    let res = upDateSerialNumberState(param);
                    if (res.state && res.state === 'error') {
                        this.$message.error('流水号生成失败');
                    }
                }
            },
            convertCurrency (money) {
	    	  // 汉字的数字
			  var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
			  // 基本单位
			  var cnIntRadice = new Array('', '拾', '佰', '仟');
			  // 对应整数部分扩展单位
			  var cnIntUnits = new Array('', '万', '亿', '兆');
			  // 对应小数部分单位
			  var cnDecUnits = new Array('角', '分', '毫', '厘');
			  // 整数金额时后面跟的字符
			  var cnInteger = '整';
			  // 整型完以后的单位
			  var cnIntLast = '元';
			  // 最大处理的数字
			  var maxNum = 999999999999999.9999;
			  // 金额整数部分
			  var integerNum;
			  // 金额小数部分
			  var decimalNum;
			  // 输出的中文金额字符串
			  var chineseStr = '';
			  // 分离金额后用的数组，预定义
			  var parts;
			  if (money == '') { return ''; }
			  money = parseFloat(money);
			  if (money >= maxNum) {
			    // 超出最大处理数字
			    return '';
			  }
			  if (money == 0) {
			    chineseStr = cnNums[0] + cnIntLast + cnInteger;
			    return chineseStr;
			  }
			  // 转换为字符串
			  money = money.toString();
			  if (money.indexOf('.') == -1) {
			    integerNum = money;
			    decimalNum = '';
			  } else {
			    parts = money.split('.');
			    integerNum = parts[0];
			    decimalNum = parts[1].substr(0, 4);
			  }
			  // 获取整型部分转换
			  if (parseInt(integerNum, 10) > 0) {
			    var zeroCount = 0;
			    var IntLen = integerNum.length;
			    for (var i = 0; i < IntLen; i++) {
			      var n = integerNum.substr(i, 1);
			      var p = IntLen - i - 1;
			      var q = p / 4;
			      var m = p % 4;
			      if (n == '0') {
			        zeroCount++;
			      } else {
			        if (zeroCount > 0) {
			          chineseStr += cnNums[0];
			        }
			        // 归零
			        zeroCount = 0;
			        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
			      }
			      if (m == 0 && zeroCount < 4) {
			        chineseStr += cnIntUnits[q];
			      }
			    }
			    chineseStr += cnIntLast;
			  }
			  // 小数部分
			  if (decimalNum != '') {
			    var decLen = decimalNum.length;
			    for (var i = 0; i < decLen; i++) {
			      var n = decimalNum.substr(i, 1);
			      if (n != '0') {
			        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
			      }
			    }
			  }
			  if (chineseStr == '') {
			    chineseStr += cnNums[0] + cnIntLast + cnInteger;
			  } else if (decimalNum == '') {
			    chineseStr += cnInteger;
			  }
			  return chineseStr;
            },
            viewHistoryApproval (row) {
                // console.log(row);
            },
            setClassName ({row, index}) {
                // 通过自己的逻辑返回一个class或者空
                return row.hasOwnProperty('children') ? '' : 'expand';
            },
            closeApprovalTemplate (param) { // 提供子组件调用
                this.isShowApprovalTemplate = false;
                if ((this.belongProcessFlag === 1 || this.belongProcessFlag === 2) && param.index === '3') {
                    this.$emit('handleApplyTabClick', param);
                } else {
                    this._getFormData();
                }
            },
            handleFullScreenForApproval () {
                this.$emit('handleFullScreenForApproval');
            },
            handleHideProcessInfo () {
                if (!this.hideProcessInfo) {
                    this.isShowProcessInfo = false;
                } else {
                    this.isShowProcessInfo = true;
                }
            },
            getApprovalList (row) {
                let resList = [];
                resList.push(row);
                return resList;
            },
            messageTip (msg, type) {
                this.$message({
                    message: msg,
                    type: type,
                    duration: 3000
                });
            },
            isHasAuth () {
                let isEditAuth = false;
                let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
                if (currentUserStr) {
                    let currentUserInfo = JSON.parse(currentUserStr);
                    let resources = currentUserInfo.resources;
                    if (resources) {
                        for (let i = 0; i < resources.length; i++) {
                            if (resources[i].resourceUrl === 'seeAllApprove') { // 是否可以点击报表进行数据修改
                                isEditAuth = true;
                                break;
                            }
                        }
                    }
                }
                return isEditAuth;
            },
            showAllApprove () {
                this.isShowAllApprove = true;
            },
            chooseProcessAssigneeUser () {
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.processUserOrgPop._initPage();
                }, 0);
                this.isShowProcessUserOrg = true;
            },
            transferApproval (row) {
                this.loadTimer2 = new Date().getTime();
                // 展现人员
                setTimeout(() => { // 初始化
                    this.$refs.transferUserOrgPop._initPage();
                }, 0);
                this.transferApprovalData = row;
                this.isShowTransferUser = true;
            },
            processAssigneeSelectTrigger (selected) { // 流程负责人
                this.selectedProcessUser = selected;
                this.searchParams.selectedUserIds = this.selectedProcessUser.selectedUserIds;
                this.searchParams.selectedUserNames = this.selectedProcessUser.selectedUserNames;
                this.handleSearch();
            },
            async transferSelectTrigger (selected) {
                // 判断当前人是否在此流程上
                let approvalList = this.transferApprovalData.approvalList;
                let canTransfer = false;
                approvalList.forEach(item => {
                    // console.log(selected.selectedUserIds);
                    item.forEach(item1 => {
                        if (selected.selectedUserIds === item1.userId) {
                            canTransfer = true;
                        }
                    });
                });
                if (canTransfer) { // 审批流存在此人，转办失败
                    this.$message.error('审批流存在此人，转办失败');
                } else { // 开始转办
                    let param = {id: this.transferApprovalData.id, transferUserid: selected.selectedUserIds};
                    let res = await updateApprovalUser(param);
                    if (res.state === 'success') {
                        this.handleSearch();
                    } else {
                        this.$message.error(res.msg);
                    }
                }
            },
            async chooseSearchConditon () {
                this.isShowSearchConditon = false;
                let searchCondition = this.$refs.searchConditon.getSearchCondition();
                // 关联字段查询用-view,否则有些查不到
                if (searchCondition && searchCondition.length > 0) {
                    for (let i = 0; i < searchCondition.length; i++) {
                        let cur = searchCondition[i];
                        if (cur.type === 'link') {
                            cur.searchFieldId = cur.id + '-view';
                        }
                    }
                }
                this.page.currentPage = 1; // 分页重置为了1
                this.searchParams.formFieldSearchMode = true;
                this.searchParams.searchCondition = searchCondition;
                this.conditionFields = cloneDeep(searchCondition);
                await this._getFormData();
            },
            async resetSearchConditon () {
                this.conditionFields.length = 0;
                setTimeout(() => {
                    this.$refs.searchConditon.handleSelectForm(this.selectedModel);
                }, 0);
                // this.conditionLoaderKey = new Date().getTime();
            },
            handleFormFieldSearch () {
                this.isShowSearchConditon = true;
                if (!this.formFieldSearchMode) {
                    this.formFieldSearchMode = true;
                    this[constants.VUEX_ACTIONS_SIDEBAR_TOGGLE]();
                }
                // console.log(this.conditionFields);
                // this.conditionLoaderKey = new Date().getTime();
            },
            handleClose (done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
            async updCarbonCopy (row) {
                let carbonCopyReadModel = {};
                carbonCopyReadModel.sendUser = row.createdBy;
                carbonCopyReadModel.sendTime = row.created;
                carbonCopyReadModel.msgStatus = 1;
                carbonCopyReadModel.msgType = 1;
                carbonCopyReadModel.approvalInstanceId = row.id;
                await updCarbonCopy(carbonCopyReadModel);
            }
        }
    };
</script>

<style lang="less">
    .approval-list {
        .data-page{
            margin-top: 1vh;
        }
        .el-header {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .el-main {
            padding: 0;
        }

        .el-aside {
            border-right: 1px solid #dcdfe6;
        }
        .el-step__main .el-breadcrumb{
            display: inline-block;
        }
        .success-step{
          .el-step__head{
              color: #67c23a;
              border-color: #67c23a;
              .is-success{
                color: #67c23a;
                border-color: #67c23a;
              }
          }
          .el-breadcrumb__inner{
                color: #c0c4cc;
                .is-success{
                    color: #67c23a;
                    border-color: #67c23a;
                }
           }
           .success-user .el-breadcrumb__inner{
               color: #67c23a;
           }
          .el-step__title{
              color: #67c23a;
          }
          .el-step__description{
              color: #303133;
          }
          .el-step__line {
            position: absolute;
            border-color: inherit;
            background-color: #67c23a;
            color: #67c23a;
          }
        }
        .reject-step{
          .el-step__head{
              color: #f56c6c;
              border-color: #f56c6c;
          }
           .el-breadcrumb__inner{
                color: #c0c4cc;
           }
           .reject-user .el-breadcrumb__inner{
               color: #f56c6c;
           }
          .el-step__title{
              color: #f56c6c;
          }
          .el-step__description{
              color: #303133;
          }
          // .el-step__line {
          //   position: absolute;
          //   border-color: inherit;
          //   background-color: #f56c6c;
          //   color: #f56c6c;
          // }
        }
// is-wait
        .now-step{
          .el-step__head{
              color: #409eff;
              border-color: #409eff;
              .is-success{
                color: #409eff;
                border-color: #409eff;
              }
          }
          .el-breadcrumb__inner{
                color: #409eff;
                border-color: #409eff;
                .is-success{
                    color: #409eff;
                    border-color: #409eff;
                }
            }
          .el-step__title{
              color: #409eff;
              .is-process{
                font-weight: 700;
              }
          }
          .el-step__line {
            position: absolute;
            border-color: inherit;
            background-color: #409eff;
            color: #409eff;
          }
            .reject-user .el-breadcrumb__inner{
                color: #f56c6c;
            }
            .success-user .el-breadcrumb__inner{
                color: #67c23a;
            }
        }
        .success-user .el-breadcrumb__inner{
            color: #67c23a;
        }
        .el-tabs__content{
          margin-top: 2px;
        }
        // .el-dialog__footer{
        //     padding: 5px 20px 10px;
        // }
        .el-dialog__header{
          padding: 5px 20px 10px;
        }
        .el-dialog__footer{
          padding: 65px 20px 5px 5px;
        }
        .el-dialog__body{
          height: 540px;
          padding: 5px 5px;
        }
        // .el-dialog__wrapper{
        //   overflow:hidden;
        // }

        .demo-table-expand {
          font-size: 0;
          .approval-steps{
            .el-form-item__content{
              margin-left: -10%;
              width: 95%;
            }
          }
        }
        .demo-table-expand label {
          width: 90px;
          color: #99a9bf;
        }
        .demo-table-expand .el-form-item {
          margin-right: 0;
          margin-bottom: 0;
          width: 33%;
        }
        .approval-info{
          .el-form-item__content{
            margin-left: -25px;
          }
        }
        .expand .el-table__expand-column .cell {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Approve/MyApproveList.vue